// extracted by mini-css-extract-plugin
export default {"legalText":"TopicIndexedMessage-module__legalText--JT5zO"};